"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _tinymce = _interopRequireDefault(require("tinymce"));

var _transformer = require("../utils/transformer");

function getPreProcessHandler(editor) {
  var _getHtmlTransforms = (0, _transformer.getHtmlTransforms)(editor),
      preProcess = _getHtmlTransforms.preProcess;

  return function (event) {
    event.content = (0, _transformer.applyDomFilters)(event.content, preProcess);
  };
}

function getPostProcessHandler(editor) {
  var _getHtmlTransforms2 = (0, _transformer.getHtmlTransforms)(editor),
      postProcess = _getHtmlTransforms2.postProcess;

  return function (event) {
    event.content = (0, _transformer.applyDomFilters)(event.content, postProcess);
  };
}

function transformerPlugin(editor) {
  editor.on('beforesetcontent', getPreProcessHandler(editor));
  editor.on('postprocess', getPostProcessHandler(editor));
  editor.on('remove', (0, _transformer.getRemoveTransformsHandler)(editor));
}

_tinymce.default.PluginManager.add('hstransformer', transformerPlugin);